<template>
    <tr class="ticket-row d-flex align-items-center" :class="statusClass">
        <td class="col-2">{{
                registrationCategory.date | dateFormat('Europe/London', 'Do MMM YYYY HH:mm')
            }}
        </td>
        <td class="col-4">
            <!--Race Components -->
            <race-components :components="registrationCategory.components" v-if="showRaceComponents"></race-components>
            <strong>{{ registrationCategory.name }}</strong>
            <p class="mb-0" v-if="registrationCategory.has_restrictions" style="font-style: italic">
                {{ registrationCategory.entry_restrictions_text }}</p>
        </td>
        <td class="text-center col-4">
            <price :price="registrationCategory.current_price">
                <template #free>£0.00</template>
                <template #description>{{ registrationCategory.current_price.description }}</template>
                <template #price-rise>
                    <next-price-text :price="registrationCategory.next_price" v-if="registrationCategory.next_price !== null"></next-price-text>
                </template>
            </price>
        </td>
        <td class="col-2">
            <enter-btn :registration-category="registrationCategory"></enter-btn>
        </td>
    </tr>
</template>

<script>

import BulkPurchaseBtn from "./../Utility/BulkPurchaseBtn";
import RaceComponents from "../Utility/RaceComponents";
import EnterBtn from "./../Utility/EnterBtn";
import NextPriceText from "../Utility/NextPriceText";
import Price from "./../Utility/Price";
import StatusBadge from "./../Utility/StatusBadge";

import {dateFormat, daysHoursUntilDateTime, timeFormat} from "../../../Utility/filters/dates"


export default {
    name: "Row",
    components: {
        BulkPurchaseBtn,
        RaceComponents,
        EnterBtn,
        NextPriceText,
        Price,
        StatusBadge
    },
    filters: {
        dateFormat,
        daysHoursUntilDateTime,
        timeFormat
    },
    props: {
        registrationCategory: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    computed: {
        statusClass() {
            switch (this.registrationCategory.human_status) {
                case 'human_status_open':
                    return 'open';

                case 'human_status_closed':
                case 'human_status_full':
                    return 'closed';

                case 'human_status_waiting_list':
                    return 'waiting-list';
            }
        },
        showRaceComponents() {
            return this.registrationCategory.components !== undefined && this.registrationCategory.components !== null;
        }
    },
}
</script>

<style scoped lang="scss">
$open: #6fa551;
$closed: #dc143c;
$waitingList: #ecb618;

td {
    font-size: 0.85rem;
    border-top:0px;
}

tr {
    &.ticket-row {
        border-left: 8px solid;
        border-bottom: 1px solid #ccc;
    }

    &.open {
        border-left-color: $open;
    }

    &.closed {
        border-left-color: $closed;
    }

    &.waiting-list {
        border-left-color: $waitingList;
    }
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Table/Row.vue